import React from 'react';

import { Flex, Text } from '@chakra-ui/react';

import { Button } from 'components';

interface ActivityFooterProps {
  onCancel: () => void
  onDelete: () => void
  isNew?: boolean
  isLoading?: boolean
}

export default function Footer({
  onCancel, onDelete, isLoading, isNew = false,
}:ActivityFooterProps) {
  return (
    <Flex
      mt={4}
      align="center"
      justify={isNew ? 'flex-end' : 'space-between'}>
      <Button
        isLoading={isLoading}
        onClick={onDelete}
        hidden={isNew}
        size="lg"
        w="fit-content"
        variant="ghost.teal">
        <Text color="red">Excluir Atividade</Text>
      </Button>
      <Flex>
        <Button
          isLoading={isLoading}
          onClick={onCancel}
          mr={2}
          variant="secondary.blue">
          <Text
            variant="smallBold"
            color="primary.default">Cancelar
          </Text>
        </Button>
        <Button
          type="submit"
          isLoading={isLoading}
          variant="primary.blue">
          <Text variant="smallBold">Salvar Atividade</Text>
        </Button>
      </Flex>
    </Flex>
  );
}
